// ====================
// |  WIDGET CONFIGS  |
// ====================
export var TagNameDisplay;
(function (TagNameDisplay) {
    TagNameDisplay["Name"] = "name";
    TagNameDisplay["Description"] = "description";
    TagNameDisplay["Both"] = "both";
})(TagNameDisplay || (TagNameDisplay = {}));
export var SubtotalsOptions;
(function (SubtotalsOptions) {
    SubtotalsOptions[SubtotalsOptions["DISABLED"] = 0] = "DISABLED";
    SubtotalsOptions[SubtotalsOptions["BEFORE"] = 1] = "BEFORE";
    SubtotalsOptions[SubtotalsOptions["AFTER"] = 2] = "AFTER";
})(SubtotalsOptions || (SubtotalsOptions = {}));
export var LabelOptions;
(function (LabelOptions) {
    LabelOptions[LabelOptions["NAME_DESCRIPTION"] = 0] = "NAME_DESCRIPTION";
    LabelOptions[LabelOptions["NAME"] = 1] = "NAME";
    LabelOptions[LabelOptions["DESCRIPTION"] = 2] = "DESCRIPTION";
})(LabelOptions || (LabelOptions = {}));
export var InMemoryDatabaseEventType;
(function (InMemoryDatabaseEventType) {
    InMemoryDatabaseEventType["TAG_CONTEXT_LOADED"] = "TAG_CONTEXT_LOADED";
    InMemoryDatabaseEventType["CELLS_LOADED"] = "CELLS_LOADED";
    InMemoryDatabaseEventType["CHANGES_LOADED"] = "CHANGES_LOADED";
    InMemoryDatabaseEventType["CHANGE_APPLIED"] = "CHANGE_APPLIED";
    InMemoryDatabaseEventType["ACCOUNT_TAG_CALCULATED"] = "ACCOUNT_TAG_CALCULATED";
    InMemoryDatabaseEventType["BTREE_INDEX_UPDATE"] = "BTREE_INDEX_UPDATE";
    InMemoryDatabaseEventType["BITMAP_INDEX_UPDATE"] = "BITMAP_INDEX_UPDATE";
})(InMemoryDatabaseEventType || (InMemoryDatabaseEventType = {}));
